import {ExpiresStatus, GetExpireStatusParams} from '$constants/api-infos'
import {createTanstackQuery} from '$utils/createQuery'

export const getConnectExpiresQuery = createTanstackQuery<ExpiresStatus, GetExpireStatusParams>((params) => ({
    url: '/connect/expires',
    method: 'GET',
    params,
}))
